import z from "zod";

import { createIdSchema } from "@/schemas/createId";
import {
  examResultCodeSchema,
  examSubjectCodeSchema,
  examTypeCodeSchema,
} from "@/types/exam";

export const ExamResultSchema = z.object({
  name: examResultCodeSchema,
  score: z.string().nullable(),
  maxScore: z.string().nullable(),
});

export const ExamSchema = z.object({
  id: z.string(),
  exam: examTypeCodeSchema,
  subject: examSubjectCodeSchema.nullable(),
  customName: z.string().nullable(),
  results: z.array(ExamResultSchema),
});
export type Exam = z.infer<typeof ExamSchema>;

export const ExamCreateSchema = ExamSchema.extend({ id: createIdSchema });
export type ExamCreate = z.infer<typeof ExamCreateSchema>;
